"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Edit = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 15,
  viewBox: "0 0 16 15",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M0 11.877v3.125h3.333l9.831-9.217L9.831 2.66 0 11.877zM15.742 3.37a.794.794 0 000-1.175l-2.08-1.95a.927.927 0 00-1.253 0l-1.627 1.525 3.334 3.125 1.626-1.525z",
  className: "fill"
}));
var _default = exports.default = Edit;